module.exports = __webpack_public_path__ + "img/heart.86646253.svg";